import camelize from 'camelize';
import { takeLatest, put, select } from 'redux-saga/effects';
import { uploadsSelector } from '../selectors';
import mergeWithFakeUploadAttachmentMessages from '../helpers/mergeWithFakeUploadAttachmentMessages';
import chatConsts from '../constants';
import { consts as metadata } from '../../board/metadata';

function* fetchMessagesWorker(action) {
  const { channelId, messages = [] } = action.payload;

  const state = yield select();
  const uploads = uploadsSelector(state);

  const attachments = uploads[channelId] || {};
  const camelizedMessages = camelize(messages);

  yield put({
    type: chatConsts.CHECK_NEW_NOTIFICATIONS,
    payload: {
      channelId,
      messages: camelizedMessages,
    },
  });

  yield put({
    type: chatConsts.SET_CHANNEL_DATA,
    payload: {
      ...action.payload,
      messages: mergeWithFakeUploadAttachmentMessages(
        camelizedMessages,
        attachments,
      ),
    },
  });

  yield put({
    type: metadata.GET_CHANNEL_METADATA,
    payload: action.payload,
  });
}

export default function* fetchMessagesSaga() {
  yield takeLatest([chatConsts.FETCH_MESSAGES], fetchMessagesWorker);
}



// WEBPACK FOOTER //
// ./src/redux/chatConnection/sagas/fetchMessages.js